import BaseService from '../core/service/BaseService';

const url = 'apuracoes-metas';
class ApuracaoMetaService extends BaseService {
    async finalizarAvaliacao(idApuracao, params) {
        const response = await window.$http.patch(
            `${url}/avaliacao-resultado/${idApuracao}`,
            params
        );
        return response;
    }
}

export default new ApuracaoMetaService(url);
